import type { IAppState } from '../../modules/App/interfaces/IAppState'
import type { IFilters } from '../../shared/interfaces/filters/IFilters'

export const filtersSelector = (state: IAppState): IFilters => state.filters
